import styled from '@emotion/styled';
import {IconChevronRight} from '@travel-frontend/icons';

export const Chevron = styled(IconChevronRight)`
  margin-left: 4px;
`;
